import React, { useState, useEffect } from 'react';

import { useAppContext } from '../context/AppContext';
import api from '../services/api';

function sanitizePersistedAudio(audio) {
  if (!audio || typeof audio !== 'object') return null;
  const safeAudio = {
    fileName: audio.fileName || audio.audioRef || null,
    audioRef: audio.audioRef || audio.fileName || null,
    tipo: audio.tipo || null,
    voiceName: audio.voiceName || null,
    mixed: !!audio.mixed,
    previewUrl: null
  };
  return safeAudio.audioRef ? safeAudio : null;
}

function ResultadoScreen() {
  const {
    spot,
    salvarSpot,
    audioGerado,
    setAudioGerado,
    setTela
  } = useAppContext();

  useEffect(() => {
    if (!audioGerado) {
      const saved = sessionStorage.getItem('radio-ai-audio');
      if (saved) {
        try {
          const safeAudio = sanitizePersistedAudio(JSON.parse(saved));
          if (safeAudio) {
            setAudioGerado(safeAudio);
            sessionStorage.setItem('radio-ai-audio', JSON.stringify(safeAudio));
          }
        } catch {
          sessionStorage.removeItem('radio-ai-audio');
        }
      }
    }
  }, [audioGerado, setAudioGerado]);

  const [loadingAudio, setLoadingAudio] = useState(false);
  const [erro, setErro] = useState('');
  const [tipoVozSelecionado, setTipoVozSelecionado] = useState('comercial');

  const gerarAudio = async () => {
    const textoFinal = (spot.textoMelhorado || spot.texto || '').trim();
    if (!textoFinal) {
      setErro('Digite o texto do spot antes de gerar.');
      return;
    }

    setLoadingAudio(true);
    setErro('');

    try {
      const result = await api.generateAudio({
        text: textoFinal,
        tipo: tipoVozSelecionado
      });

      if (result.success) {
        const audioData = {
          previewUrl: result.audioUrl || null,
          audioRef: result.audioRef || result.fileName,
          fileName: result.fileName,
          tipo: result.tipo,
          voiceName: result.voiceName,
          mixed: result.mixed
        };

        const persistedAudio = sanitizePersistedAudio(audioData);
        setAudioGerado(audioData);
        sessionStorage.setItem('radio-ai-audio', JSON.stringify(persistedAudio));
      } else {
        setErro(result.error || 'Erro ao gerar áudio.');
      }
    } catch (error) {
      setErro('Erro ao gerar áudio.');
    } finally {
      setLoadingAudio(false);
    }
  };

  const textoAtual = spot.textoMelhorado ?? spot.texto ?? '';

  return (
    <div className="page">

      <h1 className="page-title">Gerar Spot</h1>

      <div className="page-content">

        <div className="card">
          <div className="section-title">Texto do Spot</div>

          <textarea
            className="textarea"
            value={textoAtual}
            onChange={(e) => salvarSpot('textoMelhorado', e.target.value)}
            placeholder="Digite o texto..."
          />
        </div>

        <div className="card">
          <div className="section-title">Tipo de Voz</div>

          <select
            className="select"
            value={tipoVozSelecionado}
            onChange={(e) => setTipoVozSelecionado(e.target.value)}
            disabled={loadingAudio}
          >
            <option value="comercial">Comercial</option>
            <option value="evento">Evento</option>
            <option value="news">Notícia</option>
            <option value="locutor">Locutor</option>
          </select>
        </div>

        {erro && <div className="alert-error">{erro}</div>}

        <div style={{ display: 'flex', gap: '12px' }}>
          <button
            className="btn"
            onClick={gerarAudio}
            disabled={loadingAudio || !textoAtual.trim()}
            style={{ padding: '8px 16px', fontSize: '13px' }}
          >
            {loadingAudio ? 'Gerando...' : 'Gerar Áudio'}
          </button>

          {audioGerado && (
            <button
              className="btn btn-secondary"
              onClick={() => setTela('eventos')}
            >
              Agendar Eventos
            </button>
          )}
        </div>

        {audioGerado && (
          <div className="card">
            <div className="section-title">Prévia</div>

            {audioGerado.previewUrl ? (
              <audio controls style={{ width: '100%' }}>
                <source src={audioGerado.previewUrl} type="audio/mpeg" />
              </audio>
            ) : (
              <div className="field-hint">
                Prévia disponível apenas na sessão em que o áudio foi gerado.
              </div>
            )}

            <div style={{ marginTop: '10px', opacity: 0.7 }}>
              {audioGerado.fileName}
            </div>
          </div>
        )}

      </div>
    </div>
  );
}

export default ResultadoScreen;
